import React from 'react'

import { StarFilledIcon } from 'src/common/components/icons/StarFilledIcon'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import { BlockFooterCard } from './BlockFooterCard/BlockFooterCard'
import { BlockFooterUsersIcon } from './BlockFooterUsersIcon'

import s from './IntroBlockFooter.module.scss'

export type IntroBlockFooterProps = {
  name: string
  clientReviewsCount: number
  developersCount: number
  rating: number
}

export const IntroBlockFooter: React.FC<IntroBlockFooterProps> = ({
  name,
  clientReviewsCount,
  developersCount,
  rating,
}) => {
  return (
    <div className={s.IntroBlockFooter}>
      <BlockFooterCard>
        <Typography
          className={s.IntroBlockFooter__header}
          variant={EnumTypographyVariants.H5}
          as="div"
        >
          {new Array(5).fill(1).map((_, i) => (
            <StarFilledIcon
              key={i}
              className={i === 4 ? s.IntroBlockFooter__icon : undefined}
            />
          ))}
          {`${rating}/5`}
        </Typography>

        <Typography
          className={s.IntroBlockFooter__title}
          variant={EnumTypographyVariants.H5}
          as="h3"
        >
          {'Clients rate Insquad '} <span>{name}</span> {' developers'}
        </Typography>

        <Typography
          className={s.IntroBlockFooter__description}
          variant={EnumTypographyVariants.H8}
        >
          {`Based on ${clientReviewsCount} client reviews`}
        </Typography>
      </BlockFooterCard>
      <BlockFooterCard>
        <Typography
          className={s.IntroBlockFooter__header}
          variant={EnumTypographyVariants.H5}
          as="div"
        >
          <BlockFooterUsersIcon className={s.IntroBlockFooter__icon} />
          {developersCount}
        </Typography>

        <Typography
          className={s.IntroBlockFooter__title}
          variant={EnumTypographyVariants.H5}
          as="h3"
        >
          {'Senior '} <span>{name}</span> {' developers are ready to start now'}
        </Typography>
      </BlockFooterCard>
    </div>
  )
}
